import React, { useLayoutEffect, useRef, useState } from "react";
import Link from '@material-ui/core/Link';
import CloseIcon from '@material-ui/icons/Close'; 
import { useSelector } from "react-redux";

let popupSequence = 0;
const activePopupIds = [];
const popupListeners = new Set();

const notifyPopupListeners = () => {
    popupListeners.forEach((listener) => listener());
};

const addPopupToStack = (popupId) => {
    if (!activePopupIds.includes(popupId)) {
        activePopupIds.push(popupId);
        notifyPopupListeners();
    }
};

const removePopupFromStack = (popupId) => {
    const popupIndex = activePopupIds.indexOf(popupId);

    if (popupIndex !== -1) {
        activePopupIds.splice(popupIndex, 1);
        notifyPopupListeners();
    }
};

const GQPopup = (props) => {

    const { innerHtml, show, close, disabled, className, styles, mountMode = 'unmount' } = props;
    const toggle = useSelector(state => state.setToggle.toggle);
    const popupIdRef = useRef(null);
    const [, setStackVersion] = useState(0);
    const keepMounted = mountMode === 'keepMounted';
    const shouldRender = show || keepMounted;

    if (popupIdRef.current === null) {
        popupSequence += 1;
        popupIdRef.current = popupSequence;
    }

    useLayoutEffect(() => {
        const handleStackChange = () => {
            setStackVersion((currentVersion) => currentVersion + 1);
        };

        popupListeners.add(handleStackChange);

        return () => {
            popupListeners.delete(handleStackChange);
        };
    }, []);

    useLayoutEffect(() => {
        if (!show) {
            removePopupFromStack(popupIdRef.current);
            return undefined;
        }

        addPopupToStack(popupIdRef.current);

        return () => {
            removePopupFromStack(popupIdRef.current);
        };
    }, [show]);

    const popupIndex = activePopupIds.indexOf(popupIdRef.current);
    const popupLayer = popupIndex === -1 ? activePopupIds.length : popupIndex;
    const showBackdrop = popupLayer === 0;
    const wrapperZIndex = 3000 + (popupLayer * 20);

    return (
        <>
        {shouldRender &&
            <div className={className} style={{position: "fixed", zIndex: wrapperZIndex, display: show ? 'block' : 'none'}}>
                {show && showBackdrop &&
                    <div className="popupBackdrop" onClick={() => {!disabled && close();}}> 
                    </div>
                }
                
                <div style={{position: "fixed", zIndex: wrapperZIndex + 10, borderRadius: "8px", top: "50%", left: "50%", transform: "translate(-50%, -50%)", backgroundColor: toggle ? "white" : "#292929", border:'1px solid #ccc', boxShadow: "0 18px 48px rgba(0, 0, 0, 0.28)", maxHeight: "95vh", display: "flex", flexDirection: "column", ...(styles || {})}}>
                    <div style={{width: "100%", padding: "5px", display: "flex", justifyContent: "flex-end"}}>
                        <Link className={"appTextColor"}><CloseIcon onClick={() => {!disabled && close();}} /></Link>
                    </div>
                                
                    <div style={{padding: "0 10px 10px 10px", overflowY: "auto", minHeight: 0}}>
                        {innerHtml}
                    </div>
                </div>
            </div>
        }
        </>
    );

}

export default GQPopup;